import { type FieldValues, type Path, type PathValue, useWatch } from 'react-hook-form';

type WatchedObject<
  TFieldValues extends FieldValues,
  TFields extends readonly Path<TFieldValues>[],
> = {
  [K in TFields[number]]: PathValue<TFieldValues, K>;
};

export function useWatchObject<const TFieldValues extends FieldValues>() {
  return function useWatchedObject<TFields extends readonly Path<TFieldValues>[]>(
    fields: TFields,
  ): WatchedObject<TFieldValues, TFields> {
    const values = useWatch<TFieldValues>({ name: fields });

    return fields.reduce(
      (watchedObject, field, index) => {
        watchedObject[field] = values[index];

        return watchedObject;
      },
      {} as WatchedObject<TFieldValues, TFields>,
    );
  };
}
